export var WEB_DIRECT_PAYMENT_CHID = 'INPAYW';
export var WEB_DIRECT_PAYMENT_TYPE = '6';
export var UX_MODE = {
  NEW_TAB: 'newTab',
  REDIRECT: 'redirect'
};
export var IAS_WEB_TOKEN = 'IAS_WEB_TOKEN';
export var RESTORE = 'RESTORE';